/** Build triggers of an app (api/openapi.yaml "Build triggers", plan P33): builds that start when the repository receives a push. */
import { BuildTrigger, BuildTriggerList, type BuildTriggerCreateRequest, type BuildTriggerPatch } from '@hangar/shared';
import { z } from 'zod';
import { api } from './client';

const enc = encodeURIComponent;

export const listBuildTriggers = (appId: string) => api('GET', `/apps/${enc(appId)}/build-triggers`, { schema: BuildTriggerList });
export const createBuildTrigger = (appId: string, body: BuildTriggerCreateRequest) => api('POST', `/apps/${enc(appId)}/build-triggers`, { schema: BuildTrigger, body });
export const updateBuildTrigger = (id: string, body: BuildTriggerPatch) => api('PATCH', `/build-triggers/${enc(id)}`, { schema: BuildTrigger, body });
export const deleteBuildTrigger = (id: string) => api('DELETE', `/build-triggers/${enc(id)}`, { schema: z.null() });
/** Registers the repository webhook again (after the token got the Webhooks permission). */
export const retryTriggerWebhook = (appId: string) => api('POST', `/apps/${enc(appId)}/build-triggers/webhook`, { schema: BuildTriggerList });
